import { CarItemSearchAttributes } from './carDataAttributes';
import { ComicItemSearchAttributes } from './comicDataAttributes';
import { WatchItemSearchAttributes } from './watchDataAttributes';
import { OtherItemSearchAttributes } from './otherDataAttributes';
import { ArtItemSearchAttributes } from './artDataAttributes';
import { AntiqueItemSearchAttributes } from './antiqueDataAttributes';
import { BookItemSearchAttributes } from './bookDataAttributes';
import { CameraItemSearchAttributes } from './cameraDataAttributes';
import { FirearmItemSearchAttributes } from './firearmDataAttributes';
import { HandbagItemSearchAttributes } from './handbagDataAttributes';
import { JewelryItemSearchAttributes } from './jewelryDataAttributes';
import { ToyItemSearchAttributes } from './toyDataAttributes';
import { SportsCardItemSearchAttributes } from './sportsCardDataAttributes';
import { VinylRecordItemSearchAttributes } from './vinylRecordDataAttributes';
import { HistoricalMemItemSearchAttributes } from './historicalMemorabiliaDataAttributes';
import { MovieMemItemSearchAttributes } from './movieMemorabiliaDataAttributes';
import { MusicalInstrumentItemSearchAttributes } from './musicalInstrumentDataAttributes';
import { MusicMemItemSearchAttributes } from './musicMemorabiliaDataAttributes';
import { SportsMemItemSearchAttributes } from './sportsMemorabiliaDataAttributes';
import { WineItemSearchAttributes } from './wineDataAttributes';

const itemSearchAttributes = {
  WATCH: WatchItemSearchAttributes,
  CAR: CarItemSearchAttributes,
  COMIC: ComicItemSearchAttributes,
  OTHER: OtherItemSearchAttributes,
  ART: ArtItemSearchAttributes,
  ANTIQUE: AntiqueItemSearchAttributes,
  BOOK: BookItemSearchAttributes,
  CAMERA: CameraItemSearchAttributes,
  FIREARM: FirearmItemSearchAttributes,
  HANDBAG: HandbagItemSearchAttributes,
  JEWELRY: JewelryItemSearchAttributes,
  TOY: ToyItemSearchAttributes,
  SPORTS_CARD: SportsCardItemSearchAttributes,
  VINYL_RECORD: VinylRecordItemSearchAttributes,
  MUSICAL_MEM: MusicMemItemSearchAttributes,
  SPORTS_MEM: SportsMemItemSearchAttributes,
  HISTORIC_MEM: HistoricalMemItemSearchAttributes,
  MOVIE_MEM: MovieMemItemSearchAttributes,
  MUSICAL_INST: MusicalInstrumentItemSearchAttributes,
  WINE: WineItemSearchAttributes,
};

export default itemSearchAttributes;



// WEBPACK FOOTER //
// ./src/config/itemSearchAttributes.js